import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import axios from '@shared/config/axios';
import { AxiosErrorAlertHandler } from '@shared/api/utils';

export const useBags = () => {
    const navigate = useNavigate();
    const alertRef = useRef();

    const [rows, setRows] = useState([]);
    const [open, setOpen] = useState(false);
    const [qrCodeValue, setQrCodeValue] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['bag'],
        queryFn: () => {
            return axios.get(`/bags`)
                .then(({ data }) => {
                    setRows(data);
                    return data;
                });
        },
        refetchOnWindowFocus: true,
        retry: false,
    });

    useEffect(() => {
        if (data) {
            setRows(data);
        }
    }, [data]);

    const handleOpenQr = async (value) => {
        try {
            const response = await axios.get('/qrcode/bags/' + value, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${value}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            alertRef.current.handleOpen('success', 'bags loaded successfully');
        } catch (error) {
            AxiosErrorAlertHandler(error, alertRef);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setQrCodeValue('');
    };

    const handleOpen = (id) => {
        navigate(`/bags/${id}`);
    };

    return {
        alertRef,
        rows,
        open,
        qrCodeValue,
        handleOpenQr,
        handleClose,
        handleOpen,
        isLoading
    };
};
